export default (title, accessory, width = 0, fixed = null, sortable = false) => {
  const opt = {
    Header: title,
    id: accessory,
    accessory,
  };
  if (width) {
    opt.width = width;
  }
  opt.fixed = fixed;
  if (sortable) {
    opt.sortable = sortable;
  }
  return opt;
};
